import { useMutation } from "@tanstack/react-query";
import { panelUpdate } from "common/api/sakusas/sakusas_panel";
import { useInvalidateQueryByKeys } from "hooks/query_common/useInvalidateQueryByKeys";
import { useQueryClient } from "@tanstack/react-query";
import { QUERY_KEYS } from "constant/react_query";

type UseSakusasPanelUpdateParams = {
  invalidateKeys?: string[];
};

export const useSakusasPanelUpdate = (
  hookParams?: UseSakusasPanelUpdateParams
) => {
  const queryClient = useQueryClient();
  const { invalidateQueriesByKeys } = useInvalidateQueryByKeys();
  const { mutate: panelUpdateMutate } = useMutation({
    mutationFn: async (params: any) =>
      await panelUpdate(params.id, params.updatePayload),
    onSuccess: () => {
      if (hookParams?.invalidateKeys) {
        invalidateQueriesByKeys(hookParams.invalidateKeys);
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEYS.SAKUSAS_VIDEO_GET],
        });
      }
    },
  });

  return { panelUpdateMutate };
};
